// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1yCP-","title":"Images90_title__2n2a9","images":"Images90_images__jkXj0"};